import styled from 'styled-components';
import { space, color, textAlign } from 'styled-system';
import { ThemeInterface } from '../theme/ThemeInterface';
import { StyledSystemProps } from '../theme/StyledSystemProps';
import { theme } from '../theme';

type Props = StyledSystemProps & {
  pointer?: boolean;
};

const Link = styled.a<Props>`
  ${space};
  ${color};
  ${textAlign};
  font-size: ${(props: ThemeInterface) => props.theme.fontSizes[0]};
  text-transform: ${(props: ThemeInterface) => props.textTransform || 'none'};
  &:hover {
    cursor: ${(props: ThemeInterface) => (props.pointer ? 'pointer' : 'default')};
  }
`;

export default Link;

Link.defaultProps = {
  color: theme.colors.charcoalGrey,
};



// WEBPACK FOOTER //
// ./src/typography/Link.ts